import { render, staticRenderFns } from "./favoriteShop.vue?vue&type=template&id=04773c90&scoped=true&"
import script from "./favoriteShop.vue?vue&type=script&lang=js&"
export * from "./favoriteShop.vue?vue&type=script&lang=js&"
import style0 from "./favoriteShop.vue?vue&type=style&index=0&id=04773c90&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04773c90",
  null
  
)

export default component.exports